import { z } from 'zod';

import { ModalSessionFlightPolicyViolationSchema } from './flight_policy_violation';
import { ModalSessionFlightSegmentViewSchema, ModalSessionMoneySchema } from './session';

/** A cotação de UMA opção de preço de voo (`quote-view`), como a bancada e o
 *  agente a leem. Evolução ADITIVA: o schema segue estrito, e um consumidor
 *  antigo rejeita campo novo — os consumidores sobem antes ou junto do emissor
 *  (a mesma régua de `hotel_search_response.ts`). */
export const ModalSessionFlightQuoteViewSchema = z
  .object({
    quoteId: z.string().min(1),
    offerId: z.string().min(1),
    fareId: z.string().min(1),
    /** A tarifa da IDA — a do itinerário inteiro quando o fornecedor vende ida e
     *  volta numa tarifa só (bundled). */
    fareName: z.string().optional(),
    /** A tarifa da VOLTA quando ela é vendida à parte (tarifa por trecho, ex.:
     *  ida LATAM + volta Azul, #3844). Ausente = a mesma de `fareName`. */
    returnFareName: z.string().optional(),
    status: z.enum(['confirmed', 'price_changed', 'expired', 'stale']).optional(),
    expiresAt: z.iso.datetime().optional(),
    price: ModalSessionMoneySchema,
    flight: ModalSessionFlightSegmentViewSchema.optional(),
    returnFlight: ModalSessionFlightSegmentViewSchema.optional(),
    baseFare: ModalSessionMoneySchema.optional(),
    baggage: z.string().optional(),
    searchPolicies: z.record(z.string(), z.unknown()).optional(),
    withinPolicy: z.boolean().optional(),
    /** As regras que reprovaram a tarifa (#5262), na ordem em que a UI as nomeia.
     *  Só com `withinPolicy: false`; ausente = dentro da política ou emissor
     *  anterior ao campo (a UI cai no aviso genérico). */
    policyViolations: z.array(ModalSessionFlightPolicyViolationSchema).optional(),
  })
  .strict();
export type ModalSessionFlightQuoteView = z.infer<typeof ModalSessionFlightQuoteViewSchema>;
